module.exports = __webpack_public_path__ + "img/1.35687b56.jpg";